module.exports = __webpack_public_path__ + "static/media/ai.417419b9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ai.svg
// module id = 802
// module chunks = 0